<script setup>
import { ref, onBeforeMount } from "vue";
import Icon from "@components/icons/Icon.vue";

const props = defineProps({
  label: String,
  items: Array,
  default: String,
  from: String,
  categoryId: Number,
});

const emit = defineEmits(["onselect", "onvertodas"]);

const showOptions = ref(false);
const selectedId = ref();
const selectedName = ref();

onBeforeMount(() => {
  selectedId.value = props.default ?? props.items[0].id;
  props.items.forEach((item) => {
    if (item.id == selectedId.value) {
      selectedName.value = item.nombre;
    }
  });
});

function toggleDropdown() {
  showOptions.value = !showOptions.value;
}

function onVerTodas(id) {
  selectedId.value = 0;
  selectedName.value = "VER TODAS";
  emit("onvertodas", id);
  showOptions.value = false;
}

function onSelect(id) {
  console.log("select item ", id);
  props.items.forEach((item) => {
    if (item.id == id && selectedId.value != id) {
      selectedId.value = id;
      selectedName.value = item.nombre;
      emit("onselect", item);
    }
  });
  showOptions.value = false;
}
</script>

<template>
  <div class="custom-select-container">
    <div
      class="row p-0 justify-content-between align-items-center m-1 pointer"
      @click.stop="toggleDropdown"
    >
      <div class="col">{{ selectedName }}</div>
      <div class="col-auto p-0">
        <Icon :name="'down'" :width="30" />
      </div>
    </div>

    <transition name="dropdown">
      <div
        v-if="showOptions"
        class="custom-select-options verTodas"
        @blur="toggleDropdown"
        @mouseleave="toggleDropdown"
        @click="toggleDropdown"
      >
        <div
          v-if="from == 'subcategories'"
          class="row align-items-center justify-content-between option-item"
          @click.stop="onVerTodas(categoryId)"
        >
          <div class="col">VER TODAS</div>
        </div>

        <div
          v-for="item in items"
          :key="`chapter_${item.id}`"
          class="row align-items-center justify-content-between option-item"
          @click.stop="onSelect(item.id)"
        >
          <div class="col">{{ item.nombre }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.custom-select-container {
  position: relative;
  width: fit-content;
  margin: 5px;
  padding: 5px;
  border-radius: 10px;
  background-color: #e7eff5;
  transition: all 0.2s ease;
  cursor: pointer;
}

.custom-select-options {
  position: absolute;
  top: 0px;
  right: 0px;
  width: fit-content;
  padding: 10px;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08), 0 4px 6px 0 rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.option-item {
  padding: 4px 10px;
  margin-top: 5px;
  margin-left: 10px;
  margin-right: 10px;
  text-wrap: nowrap;
}
.option-item:hover {
  background-color: #e7eff5;
  border-radius: 4px;
}
.option-item:hover {
  color: #ed9e00;
}

/* ---------------------------------------------------
    ANIMATIONS
----------------------------------------------------- */
.dropdown-enter-from {
  opacity: 0;
}
.dropdown-enter-to {
  opacity: 1;
}
.dropdown-enter-active {
  transition: all 0.2s ease-in;
}

.dropdown-leave-from {
  opacity: 1;
}
.dropdown-leave-to {
  opacity: 0;
}
.dropdown-leave-active {
  transition: all 0.2s ease-in-out;
}

@media (max-width: 450px) {
  .custom-select-container {
    position: inherit;
  }
  .custom-select-options {
    top: 20%;
    left: 50%;
    transform: translateX(-50%);
    max-width: 300px;
  }

  .option-item {
    text-wrap: wrap;
  }
}
</style>
